module.exports = __webpack_public_path__ + "img/arrow-big-white.ea49ff03.svg";